"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeValue = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const attributes_styles_1 = require("./attributes.styles");
const AttributeValue = ({ values }) => {
    // commented out for EN-3066
    // const valueListIcon = values.some(({ active, name }) => !active && name) && <WarningIcon />;
    const value = (0, react_1.useMemo)(() => {
        const isEmptyValue = !values.some(({ name }) => name);
        if (isEmptyValue) {
            return react_1.default.createElement("span", { className: "attribute-value-box" }, "\u2014");
        }
        const valueContent = values.map(({ name }, index) => (
        // commented out for EN-3066
        // const valueContent = values.map(({ name, active }, index) => (
        react_1.default.createElement(react_1.default.Fragment, { key: name }, react_1.default.createElement("span", { className: 'attribute-text' }, name), index !== values.length - 1 && react_1.default.createElement("span", null, ",\u00A0"))));
        return (react_1.default.createElement(ui_components_1.ToolTip, { arrow: true, title: (react_1.default.createElement(attributes_styles_1.StyledTooltipValue, null, valueContent)) }, react_1.default.createElement("div", { className: "attribute-value-box" }, valueContent)));
    }, [values]);
    return (react_1.default.createElement(attributes_styles_1.StyledAttributeContainerCell, null, value));
};
exports.AttributeValue = AttributeValue;
exports.default = exports.AttributeValue;
